exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#elDialog .el-dialog__title {\r\n    line-height: 24px;\r\n    font-size: 18px;\r\n    color: #303133;\r\n    font-weight: 600;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b9214ac6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1&bustCache!./src/components/physical/childPhy.vue
// module id = o2qW
// module chunks = 3